module.exports = __webpack_public_path__ + "static/img/1000000439_red.d417ae57.jpg";